import {
  Injectable
} from '@angular/core';
import {
  IRFQViewModel,
  IPartsViewModel,
  IManufacturersViewModel,
  IManufactureGroupList,
  ICustomProcessViewModel,
  IMessagesViewModel,
  IRfqNDAViewModel,
  IRFQRevisionModel,
  ISupplierRFQViewModel,
  IBuyerRfqFilterViewModel,
  IVisionWidgetDraftRFQRequest,
  IVisionWidgetDraftRFQListResponse,
  DownloadAllFilesViewModel,
  IMessageListViewModel,
  IProcessModel,
  IFeedbackBuyerViewModel,
  IFeedbackSaveViewModel,
  IRFQPartQuantityQuote,
  IBuyerQuotesViewModel,
  AwardingModelQuoteDetailsRequestViewModel,
  DownloadQuotesToExcelViewModel,
  ILeadUserViewModel,
  DistributionPostModel, DistributionChildAccountsViewModel, MaterialsRequestViewModel, PostProductionProcessRequestViewModel







} from '../../models/rfqModel';
import {profileManagementRequestViewModel} from '../../models/profileModel'
import {
  IMaterialViewModel,
  IPostProductionViewModel,
  IBuyerListByCompanyIdModel,
  IMaterialGradeViewModel,
  IWidgetMaterialGradesRequest
} from '../../models/globalMaster';
import {
  DataService
} from '../data.service';
import {
  Observable
} from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import {
  HttpClient
} from '@angular/common/http';
import {
  IPartLibraryModel
} from '../../models/partModel';
import {
  INDAViewModel
} from '../../models/settingsModel';
import {
  Subject
} from 'rxjs/Subject';
import {
  ToastrService
} from 'ngx-toastr';
import { RFQTrackerRequestViewModel, RFQTrackerResponseViewModel } from '../../models/actionTrackerModel';

@Injectable()
export class RfqService {
  moduleUrl: string;
  private retryLimit = 1;
  data: any = {
    rfqId: 0
  };

  set(data: any, key: string) {
    this.data[key] = data;
  }

  get(key: string) {
    return this.data[key];
  }

  isInstantPurchaseViewOnly(fallbackRfq?: { isInstantPurchaseEligible?: boolean }): boolean {
    const rfq = this.get('irfqViewModel') || fallbackRfq;
    return !!rfq && !!rfq.isInstantPurchaseEligible;
  }
  // tslint:disable-next-line:member-ordering
  private subjectRfq = new Subject < any > ();
  // tslint:disable-next-line:member-ordering
  private subjectShipping = new Subject < any > ();
  // tslint:disable-next-line:member-ordering
  private partAddedFromLibrary = new Subject < any > ();
  // tslint:disable-next-line:member-ordering
  private closedFromMessage = new Subject < any > ();
  // tslint:disable-next-line:member-ordering
  private closedFromCustomNda = new Subject < any > ();
  // tslint:disable-next-line:member-ordering
  private GetRfqModel = new Subject < any > ();
  private closePartDrawer = new Subject < any > ();
  closePartDrawerStatus = this.closePartDrawer.asObservable();
  isWarningShown: boolean;
  constructor(private _dataService: DataService, private _httpClient: HttpClient, private _toastr: ToastrService) {
    this.isWarningShown = false;
  }

  addRFQDetails(rfqModel: IRFQViewModel): Observable < IRFQViewModel > {
    this.moduleUrl = 'RFQ';
    return this._dataService.add(this.moduleUrl, rfqModel);
  }
  AddRFQExtraDetails(rfqModel: IRFQViewModel): Observable < IRFQViewModel > {
    this.moduleUrl = 'RFQ/UpdateRFQDetails';
    return this._dataService.add(this.moduleUrl, rfqModel);
  }

  getRFQExtraDetails(rfqId: number, supplierContactId: number, rfqGuid: string): Observable < IRFQViewModel > {
    // this.moduleUrl = 'RFQ/ShowRFQDetails?rfqId=';
    // return this._dataService.getSingle(this.moduleUrl, rfqId);
    this.moduleUrl = 'RFQ/ShowRFQDetails?rfqId=' + rfqId + '&supplierContactId=' + supplierContactId + '&rfqGuid=' + rfqGuid +'&isVisionUser=' + true;
    return this._dataService.getAll(this.moduleUrl, '');
  }
  removeCustomNDAfromRFQ(ndaFileName: string, contactID: number, rfqID: number): Observable < any > {
    this.moduleUrl = 'RFQ/RemoveCustomNDAFiles?FileName=' + ndaFileName + '&ContactId=' + contactID + '&RfqId=' + rfqID;
    return this._dataService.add(this.moduleUrl, '');
  }
  // addPart(rfqModel: IPartsViewModel): Observable<IPartsViewModel> {
  //   this.moduleUrl = 'RFQ/InsertPartDetails';
  //   return this._dataService.add(this.moduleUrl, rfqModel);
  // }
  addPartDetails(partsModel: IPartsViewModel): Observable < IPartsViewModel > {
    this.moduleUrl = 'RFQ/InsertPartDetails';
    return this._dataService.add(this.moduleUrl, partsModel);
  }
  addPartToRFQ(rfqModel: IPartsViewModel): Observable < IPartsViewModel > {
    this.moduleUrl = 'RFQ/AddPartFromPartLibrary';
    return this._dataService.add(this.moduleUrl, rfqModel);
  }

  uploadFile(data: any): Observable < any > {
    this.moduleUrl = 'Upload/UploadFileNDA';
    return this._dataService.add(this.moduleUrl, data);
  }

  uploadFileViaURL(fileUrl: string): Observable < any > {
    this.moduleUrl = 'Upload/GetFileURL?filename=' + fileUrl;
    return this._dataService.add(this.moduleUrl, '');
  }


  deletePart(id: any): Observable < IPartsViewModel > {
    this.moduleUrl = 'RFQ/RemoveRFQPartFile?RfqPartId=' + id + '&IsRemovedFromVision=true';
    return this._dataService.delete(this.moduleUrl, '');
  }

  moveToPart(partModel: IPartsViewModel): Observable < IPartsViewModel > {
    this.moduleUrl = 'RFQ/MoveToRFQPartFile';
    return this._dataService.add(this.moduleUrl, partModel);
  }

  getRfqParts(id: any): Observable < IPartsViewModel[] > {
    this.moduleUrl = 'RFQ/GetPartsByRfqId?isLoginFromVision=true&RfqId=';
    return this._dataService.getAll(this.moduleUrl, id);
  }
  getRfq(id: any): Observable < IRFQViewModel[] > {
    this.moduleUrl = 'RFQ/GetRFQInProgressList?contactId=';
    return this._dataService.getAll(this.moduleUrl, id);
  }

  getMyRfq(id: any): Observable < IRFQViewModel[] > {
    this.moduleUrl = 'RFQ/GetMyRFQList?contactId=';
    // this.moduleUrl = 'RFQ/GetRFQInProgressList?contactId=';
    return this._dataService.getAll(this.moduleUrl, id);
  }
  getPartDetails(partId: number, rfqPratd: number): Observable < IPartsViewModel > {
    this.moduleUrl = 'RFQ/GetPartDetailsById?isLoginFromVision=true&id=' + partId + '&RfqPartId=' + rfqPratd;
    return this._dataService.getSingle(this.moduleUrl, '');
  }
  adddRfqGeneralAttachment(rfqModel: IRFQViewModel): Observable < IRFQViewModel > {
    this.moduleUrl = 'RFQ/InsertRfqGeneralAttachments';
    return this._dataService.add(this.moduleUrl, rfqModel);
  }
  addRfqGeneralAttachment(rfqModel: IRFQViewModel): Observable < IRFQViewModel > {
    this.moduleUrl = 'RFQ/InsertRfqGeneralAttachments';
    return this._dataService.add(this.moduleUrl, rfqModel);
  }
  deleteRfqGeneralAttachment(fileName: string, contactId: number, rfqId: number): Observable < IRFQViewModel > {
    this.moduleUrl = 'RFQ/RemoveRfqGeneralAttachments?fileName=' + fileName + '&ContactId=' + contactId + '&RfqId=' + rfqId + '';
    return this._dataService.deletePost(this.moduleUrl, '');
  }
  deletePartGeneralAttachment(fileName: string, contactId: number, PartId: number, RfqPartId: number): Observable < IPartsViewModel > {
    this.moduleUrl = 'RFQ/RemovePartsGeneralAttachment?fileName=' + fileName + '&ContactId=' + contactId + '&PartId=' + PartId + '&rfqPartId=' + RfqPartId + '&isUpdatedFromVision='+ true;
    return this._dataService.deletePost(this.moduleUrl, '');
  }
  addIndividualGroupToRFQ(iManufacturersViewModel: IManufacturersViewModel): Observable < IManufacturersViewModel > {
    this.moduleUrl = 'RFQ/InsertIndividualGroupToRFQ';
    return this._dataService.add(this.moduleUrl, iManufacturersViewModel);
  }
  getManufacturesByRfq(id: any): Observable < IManufacturersViewModel > {
    this.moduleUrl = 'RFQ/GetRFQIndividualGroup?rfqId=';
    return this._dataService.getAll(this.moduleUrl, id);
  }

  removedAddedContactFromRfq(id: any): Observable < IManufactureGroupList > {
    this.moduleUrl = 'RFQ/RemoveIndividualGroup?rfqSupplierId=' + id;
    return this._dataService.add(this.moduleUrl, '');
  }

  getReviewRfqParts(id: any): Observable < IPartLibraryModel[] > {
    this.moduleUrl = 'RFQ/GetPartsByRfqId?isLoginFromVision=true&RfqId=';
    return this._dataService.getAll(this.moduleUrl, id);
  }
  updateRFQMissingInfoStatus(RFQId: number,missingInfo: boolean ): Observable < any > {
    this.moduleUrl = 'RFQ/UpdateRFQMissingInfoStatus?RFQId=' + RFQId  + '&missingInfo='+ missingInfo;
    return this._dataService.add(this.moduleUrl, '');
  }
  updateRFQStatus(statusKey, rfqID, contactId, messageDescri ? : string,missingInfo?: boolean): Observable < any > {
    this.moduleUrl = 'RFQ/UpdateRFQStatus';
    const obj = {
      rfQstatus: statusKey,
      rfqId: rfqID,
      contactId: contactId,
      messageDescr: messageDescri,
      missingInfo: missingInfo || false,
      isVisionUser:true
    
    };
    return this._dataService.updatePass(this.moduleUrl, obj);
  }

  convertToAiDraft(rfqId: number, contactId: number, companyId: number): Observable < any > {
    this.moduleUrl = 'RFQ/ConvertToAiDraft?rfqId=' + rfqId + '&contactId=' + contactId + '&companyId=' + companyId;
    return this._dataService.add(this.moduleUrl, '');
  }

  GetCustomNDAToRFQ(rfqId: number): Observable < INDAViewModel > {
    this.moduleUrl = 'RFQ/GetCustomNDAFiles?rfqId=';
    return this._dataService.getSingle(this.moduleUrl, rfqId);
  }
  cloneCurrentRFQ(rfqName: string, rfqid: number, constactId: number): Observable < any > {
    this.moduleUrl = 'RFQ/CloneRFQ?RFQName=' + rfqName + '&RFQId=' + rfqid + '&ContactId=' + constactId;
    return this._dataService.add(this.moduleUrl, '');
  }

  getS3FileDownload(filename): Observable < any > {
    this.moduleUrl = 'Upload/GetS3BucketFile?filename=' + filename + '&isFromVision=true';
    return this._dataService.add(this.moduleUrl, '');
  }
  getParentProcesses(): Observable < ICustomProcessViewModel[] > {
    this.moduleUrl = 'RFQ/GetParentProcesses';
    return this._dataService.getAll(this.moduleUrl, '');
  }
  getParentProcessesNew(): Observable < ICustomProcessViewModel[] > {
    this.moduleUrl = 'Master/GetPostProdProcesses';
    return this._dataService.getAll(this.moduleUrl, '');
  }
  getParentProcesses2(): Observable < ICustomProcessViewModel[] > {
    this.moduleUrl = 'Master/GetProcesses';
    return this._dataService.getAll(this.moduleUrl, '');
  }
  getNewParentProcesses2(): Observable < IProcessModel[] > {
    this.moduleUrl = 'Master/GetProcessesWithParent';
    return this._dataService.getAll(this.moduleUrl, '');
  }
  GetProcessesWithParentBYCompany(companyId: number): Observable < IProcessModel[] > {
    this.moduleUrl = 'Master/GetProcessesWithParent?CompanyId=' + companyId;
    return this._dataService.getAll(this.moduleUrl, '');
  }

  getProcessByCompanyId(companyId: number): Observable < ICustomProcessViewModel[] > {
    this.moduleUrl = 'Supplier/GetSuppliersProcesses?CompanyId=' + companyId;
    return this._dataService.getAll(this.moduleUrl, '');
  }
  getParentMaterial(): Observable < IMaterialViewModel[] > {
    this.moduleUrl = 'Master/GetMaterialsData';
    return this._dataService.getAll(this.moduleUrl, '');
  }
  GetPostProdProcesses(): Observable < IPostProductionViewModel[] > {
    this.moduleUrl = 'Master/GetPostProductionProcessesData';
    return this._dataService.getAll(this.moduleUrl, '');
  }
  getPartsByRfqId(rfqId: number): any {
    this.moduleUrl = 'RFQ/GetPartsByRfqId?isLoginFromVision=true&RfqId=' + rfqId;
    return this._dataService.getAll(this.moduleUrl);
  }
  transferRFQ(rfqId: number, contactTo: number): Observable < any > {
    this.moduleUrl = 'RFQ/TransferRFQ?rfq_Id=' + rfqId + '&contact_To=' + contactTo;
    return this._dataService.add(this.moduleUrl, '');
  }

  getBuyerListByCmpnyId1(cmpnyId: number): Observable < IBuyerListByCompanyIdModel[] > {
    this.moduleUrl = 'Master/BuyerListByCompanyId?CompanyId=' + cmpnyId;
    return this._dataService.getAll(this.moduleUrl, '');
  }
  getBuyerListByCmpnyId(cmpnyId: number): Observable < IBuyerListByCompanyIdModel[] > {
    this.moduleUrl = 'Contact/ContactListByCompanyId?CompanyId=' + cmpnyId;
    return this._dataService.getAll(this.moduleUrl, '');
  }

  getMessagesByRfqId(rfqId: number, contactId: number, FromContactId: number): Observable < IMessagesViewModel[] > {
    this.moduleUrl = 'Messages/GetMessagesList?rfqId=' + rfqId + '&contactId=' + contactId + '&FromContactId=' + FromContactId;
    return this._dataService.getAll(this.moduleUrl, '');
  }
  deleteMessages(messageId: number[]): Observable < any > {
    this.moduleUrl = 'Messages/DeleteMessages';
    return this._dataService.add(this.moduleUrl, messageId);
  }

  GetManufacturer(rfqId: number): Observable < IRfqNDAViewModel[] > {
    this.moduleUrl = 'RFQ/GetRFQManufacturerNDA?RFQId=' + rfqId;
    return this._dataService.getAll(this.moduleUrl, '');
  }
  GetRevesionData(rfqId: number): Observable < IRFQRevisionModel[] > {
    this.moduleUrl = 'RFQ/GetRFQRevision?RFQId=' + rfqId;
    return this._dataService.getAll(this.moduleUrl, '');
  }

  sendMessages(iMessagesViewModel: IMessagesViewModel): Observable < IMessagesViewModel > {
    this.moduleUrl = 'Messages/SendMessage';
    return this._dataService.add(this.moduleUrl, iMessagesViewModel);
  }

  manufacturerApproveDecline(iMessagesViewModel: IMessagesViewModel): Observable < IMessagesViewModel > {
    // tslint:disable-next-line:max-line-length
    this.moduleUrl = 'Messages/UpdateAuthorRecipientStatus';
    return this._dataService.add(this.moduleUrl, iMessagesViewModel);
  }
  changeMessageStatus(messageId: number): Observable < any > {
    this.moduleUrl = 'Messages/ChangeMessageStatus?messageId=' + messageId;
    return this._dataService.add(this.moduleUrl, '');
  }
  getMessageThreadByID(iMessagesViewModel: IMessagesViewModel): Observable < any > {
    this.moduleUrl = 'Messages/GetMessagesListById';
    return this._dataService.add(this.moduleUrl, iMessagesViewModel);
  }
  getSupplierRfqCount(contactId: number, companyId: number): Observable < ISupplierRFQViewModel > {
    this.moduleUrl = 'RFQ/GetSupplierRFQCount?contactId=' + contactId + '&companyId=' + companyId;
    return this._dataService.getAll(this.moduleUrl, '');
  }

  getSuppliserRfq(contactId: number, companyId: number, rfqType: number): Observable < ISupplierRFQViewModel[] > {
    this.moduleUrl = 'RFQ/GetSupplierRFQList?contactId=' + 0 + '&companyId=' + 0 + '&RfqType=' + rfqType;
    return this._dataService.getAll(this.moduleUrl, '');
  }
  AddCustomNDAToRFQ(ndaViewModel: INDAViewModel): Observable < INDAViewModel > {
    this.moduleUrl = 'RFQ/InsertCustomNDAFiles';
    return this._dataService.add(this.moduleUrl, ndaViewModel);
  }
  GetBuyerRFQList2(contactId: number, companyId: number, rfqType: number): Observable < ISupplierRFQViewModel[] > {
    this.moduleUrl = 'RFQ/GetBuyerRFQList?contactId=' + 0 + '&companyId=' + 0 + '&RfqType=' + rfqType;
    return this._dataService.getAll(this.moduleUrl, '');
  }
  GetBuyerRFQList(isupplierRfqFilterViewModel: IBuyerRfqFilterViewModel): Observable < ISupplierRFQViewModel[] > {
    this.moduleUrl = 'RFQ/GetVisionRFQList';
    return this._dataService.add(this.moduleUrl, isupplierRfqFilterViewModel);
  }

  GetVisionWidgetDraftRFQList(request: IVisionWidgetDraftRFQRequest): Observable < IVisionWidgetDraftRFQListResponse > {
    this.moduleUrl = 'RFQ/GetVisionWidgetDraftRFQList';
    return this._dataService.add(this.moduleUrl, request);
  }

  SetRfqThumbnail(contactId: number, rfqId: number, fileName: string): Observable < INDAViewModel > {
    this.moduleUrl = 'RFQ/SetRfqThumbnail?contactId=' + contactId + '&RfqId=' + rfqId + '&FileName=' + fileName;
    return this._dataService.add(this.moduleUrl, '');
  }
  RemoveRfqThumbnail(rfqId: number): Observable < INDAViewModel > {
    this.moduleUrl = 'RFQ/RemoveRfqThumbnail?RfqId=' + rfqId;
    return this._dataService.add(this.moduleUrl, '');
  }

  sendMessage(message: string) {
    this.subjectRfq.next({
      text: message
    });
  }

  clearMessage() {
    this.subjectRfq.next();
  }

  getMessage(): Observable < any > {
    return this.subjectRfq.asObservable();
  }

  sendShippingMessage(message: string) {
    this.subjectShipping.next({
      text: message
    });
  }

  getShippingMessage(): Observable < any > {
    return this.subjectShipping.asObservable();
  }


  sendpartAddedFromLibrary(message: string) {
    this.partAddedFromLibrary.next({
      text: message
    });
  }

  getpartAddedFromLibrary(): Observable < any > {
    return this.partAddedFromLibrary.asObservable();
  }

  sendclosedFromMessage(message: string) {
    this.closedFromMessage.next({
      text: message
    });
  }

  getclosedFromMessage(): Observable < any > {
    return this.closedFromMessage.asObservable();
  }
  SetIsValidatedForBuyer(contactId: number): Observable < INDAViewModel > {
    this.moduleUrl = 'Buyer/SetIsValidatedForBuyer?contactId=' + contactId + '&IsValidated=true';
    return this._dataService.add(this.moduleUrl, '');
  }
  SetunValidatedForBuyer(contactId: number): Observable < INDAViewModel > {
    this.moduleUrl = 'Buyer/SetIsValidatedForBuyer?contactId=' + contactId + '&IsValidated=false';
    return this._dataService.add(this.moduleUrl, '');
  }

  sendclosedFromCustomNda(message: string) {
    this.closedFromCustomNda.next({
      text: message
    });
  }

  getclosedFromCustomNda(): Observable < any > {
    return this.closedFromCustomNda.asObservable();
  }
  sendGetRfqModel(message: string) {
    this.GetRfqModel.next({
      text: message
    });
  }

  getGetRfqModel(): Observable < any > {
    return this.GetRfqModel.asObservable();
  }

  getMessageList(iMessagesListViewModel: IMessageListViewModel): Observable < IMessagesViewModel > {
    this.moduleUrl = 'Messages/GetMessagesListNew';
    return this._dataService.add(this.moduleUrl, iMessagesListViewModel);
  }
  handleError(error) {
    if (!this.isWarningShown) {
      if (error.status === 0) {
        this.isWarningShown = true;
        this._toastr.warning('Please check connection', 'Warning!');
      } else if (error.status === 400) {
        this.isWarningShown = true;
        this._toastr.warning(JSON.stringify(error.error), 'Warning!');
      } else if (error.status === 401) {
        this.isWarningShown = true;
        this._toastr.warning('Your session is expired. Please login again to continue.', 'Warning!');
      }
    }
  }
  getDownloadAllFileURL(downloadallfiles: DownloadAllFilesViewModel): Observable < any > {
    this.moduleUrl = 'Contact/GetDownloadAllFile';
    downloadallfiles.IsFromVision = true;
    return this._dataService.add(this.moduleUrl, downloadallfiles);
  }
  changeClosePartDrawer(status: boolean) {
    this.closePartDrawer.next(status);
  }
  setMagicLead(companyId, isMagicLeadEnable): Observable < any > {
    this.moduleUrl = 'SetMagicLeadsAccess?companyId=' + companyId + '&isMagicLeadEnable=' + isMagicLeadEnable;
    return this._dataService.add(this.moduleUrl, '');
  }
  SetRfqQuality(rfqQualityId: number, rfqID: number): Observable < any > {
    this.moduleUrl = 'RFQ/SetRfqQuality?rfqId=' + rfqID + '&rfqQualityId=' + rfqQualityId;
    return this._dataService.add(this.moduleUrl, '');
  }
  getRFQPurposeList(): Observable < any > {
    this.moduleUrl = 'Master/GetRFQPurposeList';
    return this._dataService.getAll(this.moduleUrl, '');
  }
  getAllProcess(): Observable < ICustomProcessViewModel[] > {
    this.moduleUrl = 'Master/GetAllProcesses';
    return this._dataService.getAll(this.moduleUrl, '');
  }
  getBuyerParentProcesses(): Observable < ICustomProcessViewModel[] > {
    this.moduleUrl = 'Buyer/GetBuyerParentProcesses';
    return this._dataService.getAll(this.moduleUrl, '');
  }

  getBuyerChildProcesses(buyerChildProcessViewModel: any): Observable < any > {
    this.moduleUrl = 'Buyer/GetBuyerChildProcesses';
    return this._dataService.add(this.moduleUrl, buyerChildProcessViewModel);
  }

  getSupplierList(rfqId,rfqPartId): Observable < any > {
    this.moduleUrl = 'buyer/GetAwardingModelSupplierList?rfqId=' + rfqId+ '&rfqPartId='+rfqPartId;
    return this._dataService.getAll(this.moduleUrl, '');
  }
  getQuoteFeedbackBuyer(): Observable < IFeedbackBuyerViewModel > {
    this.moduleUrl = 'Master/GetQuoteFeedbackBuyer';
    return this._dataService.getAll(this.moduleUrl, '');
  }
  SaveFeedbackBuyer(iFeedbackSaveViewModel: IFeedbackSaveViewModel): Observable < IFeedbackSaveViewModel > {
    this.moduleUrl = 'RFQQuoteFeedbackBuyer';
    return this._dataService.add(this.moduleUrl, iFeedbackSaveViewModel);
  }
  GetRFQPartQuantityQuoteBYRfqId(iRFQPartQuantityQuote: IRFQPartQuantityQuote): Observable < any > {
    this.moduleUrl = 'Supplier/GetRFQPartQuantityQuote';
    return this._dataService.add(this.moduleUrl, iRFQPartQuantityQuote);
  }
  SetRFQQuoteReviewedStatus(rfqId: number, contactId: number, IsRfqResubmitted: boolean): Observable < any > {
    this.moduleUrl = 'rfq/SetRFQQuoteReviewedStatus?rfqId=' + rfqId + '&ContactId=' + contactId + '&IsRfqResubmitted=' + IsRfqResubmitted;
    return this._dataService.add(this.moduleUrl, '');
  }
  /** Vision app only — backend: RequireVisionStaffRole; same body/response as Supplier/GetBuyerQuotingList without buyer IDOR guard. */
  GetBuyerQuotingList(iBuyerQuotesViewModel: IBuyerQuotesViewModel): Observable < any > {
    this.moduleUrl = 'Vision/BuyerQuotes/GetQuotingList';
    return this._dataService.add(this.moduleUrl, iBuyerQuotesViewModel);
  }
  getStoreAwardDetails(rfqQuoteSupplierQuoteId: number): Observable < any > {
    this.moduleUrl = 'RFQ/GetRfqContinueAwardingData?rfqId=' + rfqQuoteSupplierQuoteId;
    return this._dataService.getAll(this.moduleUrl, '');
  }
  removeSelectedAward(rfqQuoteItemsId: number): Observable < any > {
    this.moduleUrl = 'rfq/DeleteRfqContinueAwardingData?rfqQuoteItemsId=' + rfqQuoteItemsId;
    return this._dataService.getAll(this.moduleUrl, '');
  }
  SetRFQQuoteStatus(iRFQPartQuantityQuote: any): Observable < any > {
    this.moduleUrl = 'rfq/SetRFQQuoteStatus';
    return this._dataService.add(this.moduleUrl, iRFQPartQuantityQuote);
  }
  getAwardingModelQuoteQuantityData(awardingModelQuoteDetailsRequestViewModel: AwardingModelQuoteDetailsRequestViewModel): Observable < any > {
    this.moduleUrl = 'Buyer/GetAwardingModelQuoteQuantityData';
    return this._dataService.add(this.moduleUrl, awardingModelQuoteDetailsRequestViewModel);
  }
  setRfqContinueAwardingData(iRFQPartQuantityQuote: IRFQPartQuantityQuote): Observable < any > {
    this.moduleUrl = 'rfq/SetRfqContinueAwardingData';
    return this._dataService.add(this.moduleUrl, iRFQPartQuantityQuote);
  }
  DownloadQuotesToExcel(downloadQuotesToExcelViewModel: DownloadQuotesToExcelViewModel): Observable < any > {
    this.moduleUrl = 'QMS/DownloadQuotesToExcel';
    return this._dataService.add(this.moduleUrl, downloadQuotesToExcelViewModel);
  }
  setSetLeadUser(iLeadUserViewModel: ILeadUserViewModel): Observable < any > {
    this.moduleUrl = 'Leads/SetLeadUser';
    return this._dataService.add(this.moduleUrl, iLeadUserViewModel);
  }
  getQuoteDetails(rfqId: number): Observable < any > {
    this.moduleUrl = 'RFQ/GetOtherThanAwardedStatusTileData?rfqId=' + rfqId;
    return this._dataService.getAll(this.moduleUrl, '');
  }
  setRetractAward(rfqPartId: number, statusId: number, rfqId: number): Observable < any > {
    this.moduleUrl = 'RFQ/RetractOtherThanAwardedStatusTileData?rfqPartId=' + rfqPartId + '&statusId=' + statusId + '&rfqId=' + rfqId;
    return this._dataService.getAll(this.moduleUrl, '');
  }
  GetDistributionList(DistributionViewModel: DistributionPostModel): Observable < any > {
    this.moduleUrl = 'Buyer/GetDistributionList';
    return this._dataService.add(this.moduleUrl, DistributionViewModel);
  }
  getRfqFilterList(rfqId: any): Observable < any > {
    this.moduleUrl = 'BuyerRFQDistributionTabTiles?rfqId=' + rfqId;
    return this._dataService.getAll(this.moduleUrl, '');
  }
  getDistributionThreadList(DistributionViewModel: DistributionChildAccountsViewModel): Observable < any > {
    this.moduleUrl = 'Buyer/GetDistributionExpandedList';
    return this._dataService.add(this.moduleUrl, DistributionViewModel);
  }
  getMaterialByParentProcessId(materialsRequestViewModel:MaterialsRequestViewModel): Observable < IMaterialViewModel[] > {
    this.moduleUrl = 'Master/GetMaterialsDataByProcessIds';
    return this._dataService.add(this.moduleUrl, materialsRequestViewModel);
  }
  getPostProductionProcessesDataByProcessIds(postProductionProcessRequestViewModel:PostProductionProcessRequestViewModel): Observable < IPostProductionViewModel[] > {
    this.moduleUrl = 'Master/GetPostProductionProcessesDataByProcessIds';
    return this._dataService.add(this.moduleUrl, postProductionProcessRequestViewModel);
  }
  getQuestionList(processId: number): Observable < any > {
    this.moduleUrl = 'RFQPartDrawerQuestions?partCategoryId=' + processId ;
    return this._dataService.getAll(this.moduleUrl, '');
  }
  GetRFQTrackerList(rfqTrackerRequestViewModel: RFQTrackerRequestViewModel): Observable < RFQTrackerResponseViewModel[] > {
    this.moduleUrl = 'RFQTracker';
    return this._dataService.add(this.moduleUrl, rfqTrackerRequestViewModel);
  }

  getSimpleRFQ(directRfqId: number): Observable < any > {
    this.moduleUrl = 'SimpleRFQ?directRfqId=' +directRfqId;
    return this._dataService.getAll(this.moduleUrl, '');
  }

  getProfileManagement(companyId: number, accountType:any): Observable < any > {
    this.moduleUrl = 'ProfileManagement?companyId='+companyId + '&paidStatus='+accountType;
    return this._dataService.getAll(this.moduleUrl, '');
  }
  addProfileManagement(profileManagementRequestViewModel: profileManagementRequestViewModel): Observable < any > {
    this.moduleUrl = 'ProfileManagement';
    return this._dataService.add(this.moduleUrl,profileManagementRequestViewModel);
  }
  captureAwardRfqEvent(iRFQPartQuantityQuote: any): Observable < any > {
    this.moduleUrl = 'RFQ/CaptureAwardRfqEvent';
    return this._dataService.add(this.moduleUrl, iRFQPartQuantityQuote);
  }

  getCommunityRatingDataForDrawer(reviewDrawerID: any) : Observable < any > {
    this.moduleUrl = 'CommunityRatingReviews/GetCommunityRatingDataForDrawer?id='+reviewDrawerID;
    return this._dataService.getAll(this.moduleUrl, '');
  }
   //*********Background Api calling to reshape*********
   sendToReshape(RfqId:any,RfqPartId:any): Observable<any> {
    this.moduleUrl = "RFQ/ProcessPartFilesReshape?rfqId=" + RfqId + "&rfqPartId=" + RfqPartId;
    return this._dataService.getAll(this.moduleUrl,"");
  }
   // ******* Delet Api Reshape ********
   reshapeDeletePartGeneralAttachment(
    fileName: any,
    contactId: number,
    PartId: number,
    RfqPartId: number
  ): Observable<IPartsViewModel> {
    this.moduleUrl =
      "RFQ/DeletePartFilesReshape?fileName=" +
      fileName +
      "&ContactId=" +
      contactId +
      "&PartId=" +
      PartId +
      "&rfqPartId=" +
      RfqPartId;
    return this._dataService.deletePost(this.moduleUrl, "");
  }

  sendEncryptedRfqId(data): Observable<any> {
    this.moduleUrl = "RFQ/SaveEncryptedRfqId";
    return this._dataService.add(this.moduleUrl, data);
  }
  getPricingSelections(rfqId: number, contactId: number): Observable <any> {
    this.moduleUrl = 'RFQ/GetPricingSelections?rfqId=' + rfqId + '&contactId=' + contactId;
    return this._dataService.getAll(this.moduleUrl, '');
  }

  getMaterialGrades(materialId: number): Observable<IMaterialGradeViewModel[]> {
    this.moduleUrl = 'WidgetRfq/GetMaterialGrades';
    const request: IWidgetMaterialGradesRequest = { materialId };
    return this._dataService.add<any>(this.moduleUrl, request).map(response => {
      let items: any[] = [];
      if (Array.isArray(response)) {
        items = response;
      } else if (response && Array.isArray(response.data)) {
        items = response.data;
      } else if (response && response.data && Array.isArray(response.data.grades)) {
        items = response.data.grades;
      } else if (response && Array.isArray(response.grades)) {
        items = response.grades;
      } else if (response && Array.isArray(response.materialGrades)) {
        items = response.materialGrades;
      }
      return items
        .filter(item => item.isActive !== false)
        .map(item => {
          const rawId = item.gradeId != null ? item.gradeId
            : (item.GradeId != null ? item.GradeId
              : (item.id != null ? item.id
                : (item.Id != null ? item.Id
                  : (item.materialGradeId != null ? item.materialGradeId : item.MaterialGradeId))));
          const parsedId = Number(rawId);
          return {
            id: isNaN(parsedId) ? rawId : parsedId,
            name: item.gradeName || item.GradeName || item.name || item.Name
              || item.materialGradeName || item.MaterialGradeName || ''
          };
        })
        .filter(grade => grade.id != null && grade.id !== '' && grade.name);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/rfq/rfq.service.ts